import qs from 'query-string'

export type QueryParams = string | Record<string, any>

export function getApiUrl(subPath: string = '', queryParams?: QueryParams): string {
  return qs.stringifyUrl({
    url: window.API_URL + subPath,
    query: typeof queryParams === 'string' ? qs.parse(queryParams) : queryParams
  })
}

export function getBotsApiUrl(dashboard?: boolean | undefined): string {
  return `${getApiUrl()}/bots${dashboard ? '?dashboard=true' : ''}`
}

export function getDesignerUrl(): string {
  return `https://${import.meta.env.REALTIME_NAMESPACE}.feedyou.ai`
}
